import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { SessionStateService } from '../../services/session-state.service';
import { AESEncryptionService } from '../../services/aes_encryption.service';
import { DataLayerService } from 'src/app/services/data-layer.service';
import { WebengageService } from 'src/app/services/webengage.service';
import { AuthGuard } from 'src/app/auth.guard';
import jwt_decode from 'jwt-decode';
import { Defaults } from 'src/app/helpers/defaults';
// import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-callback',
  templateUrl: './callback.component.html',
  styleUrls: ['./callback.component.css']
})
export class CallbackComponent implements OnInit {
data:any;
source:any;
googleID:string='';
userEmail:string='';
userMobile:number;
Name: string='';
jwtToken: string | null = null;
decodedToken: any = null;
tokenexpired:any;
loader: HTMLElement;
ipAddress: string;
uuid:string | null =null;
constructor(private ga:DataLayerService,private userService: UserService,private router: Router, private route: ActivatedRoute, private session: SessionStateService, private authCheck: AuthGuard, private AES: AESEncryptionService,private webEngage:WebengageService) {
}

  ngOnInit() {  
    this.loader = document.querySelector('#universal_loader') as HTMLElement;
    this.loader.style.display = 'block';
    this.route.queryParams.subscribe(params => {
      this.jwtToken = params['ssotoken'] || null; 
      if (this.jwtToken) {
        // Decode the token
        try {
          // this.decodedToken = jwt_decode(this.jwtToken);
          //decode token api
          this.userService.decode_token({ "token": this.jwtToken }).subscribe(data => {
            this.decodedToken = data['body']
          this.userEmail = this.decodedToken.email;
            if (this.decodedToken['cognito:username'] && this.decodedToken['cognito:username'].includes('google_')) {
            this.googleID = this.decodedToken['cognito:username'].replace('google_', '');
            this.userMobile = 1111111111;
          } else {
            this.googleID = this.decodedToken['cognito:username'];
            this.userMobile = this.decodedToken['cognito:username'].replace('+91', '');
          }
          this.Name = this.decodedToken.name
          const currentTime = Math.floor(Date.now() / 1000); 
          if (this.decodedToken.exp && this.decodedToken.exp < currentTime) {
            this.loader.style.display = 'none';
            const modal = document.getElementById('tokenExpiredModal') as HTMLElement;
            modal.style.display = 'block';
            setTimeout(() => {
              window.location.href = Defaults.SSO_url()
            }, 2000);
          }
            else{
              this.handleLogin()
            }
          })

        } catch (error) {
          console.error('Error decoding token:', error);
        }
      }

    });
  }
  handleLogin(){
    this.data = {
      "Name":this.Name,
      "Mobile":this.userMobile,
      "Email": this.userEmail,
      "IPAddress": '',
      "GoogleID":this.googleID
    }; 
    let encrypted_data = this.AES.encrypt(this.data);
    this.userService.login_SSO({ "data": encrypted_data }).subscribe(encryptedres => {
      let res = this.AES.decrypt(encryptedres); 
      if (res.success && res.auth && res.token) {
        // Send user a notification of login
        this.notifyUserForLogin(res);

        // Store token in localStorage and session
        localStorage.setItem("token", res.token);
        this.session.setToken(res.token);

        res.data['PAN'] = this.userService.decryptPAN(res.data['PAN']);
        
        // Log response and set session states
        this.session.setState("userDetails", this.AES.encrypt(res.data));
        this.session.setState("IsClientMapped", res.data['IsClientMapped']);
        this.session.setState("DefaultPRAN", res.data['PRAN']);
        this.session.setState("DefaultPAN", res.data['PAN']);
        this.session.setState("UserId", res.data['Id']);

        // Navigate to Dashboard
        this.router.navigate(['/Dashboard']);
      } else {
        let userDetails={
          'NAME':this.Name,
          'Email':this.userEmail,
          'Mobile':this.userMobile,
          "GoogleID":this.googleID
        }
        this.session.setState("IsClientMapped", null);

        this.session.setState("DefaultPRAN", null);
        this.session.setState("DefaultPAN", null);
        this.session.setState("UserId", null);
        this.session.setState("userDetails", this.AES.encrypt(userDetails));
        this.router.navigate(['/Dashboard']);
      }
    });
  }
  getIp(){
    fetch('https://jsonip.com', { mode: 'cors' })
    .then((resp) => resp.json())
    .then((ip) => {
      this.ipAddress =  ip['ip'];
    });
  }
  
  notifyUserForLogin(res){
    //send user a notification of login
    let system = this.getSystemDetails();
    let os ='';
    let device ='';
    if(system.navigator_userAgent.includes("Windows")){
      os = "Windows";
      device = "Laptop";
    }else if(system.navigator_userAgent.includes("iPhone") && system.navigator_userAgent.includes("Mac")){
      os = "Mac";
      device = "Phone"
    }
    else if(system.navigator_userAgent.includes("Mac")){
      os = "Mac";
      device = "Laptop"
    }
    else if(system.navigator_userAgent.includes("Android")){
      os = "Android";
      device = "Phone"
    }

    let notifyData = {
      "userName": res.data['NAME'],
      "userEmail": res.data['Email'],
      "device": device,
      "browser":system.browser_name,
      "os": os,
      "ip": this.ipAddress
    }
    this.userService.notifyUser(notifyData).subscribe((res)=>{
      if(res.success){
        // console.log("Notified success",res);
      }else{
        // console.log("Notified fail",res);
      }
    });
  }

  getSystemDetails(){
    let nVer = navigator.appVersion;
    let nAgt = navigator.userAgent;
    let browserName  = navigator.appName;
    let fullVersion  = ''+parseFloat(navigator.appVersion); 
    let majorVersion = parseInt(navigator.appVersion,10);
    let nameOffset,verOffset,ix;

    // In Opera, the true version is after "Opera" or after "Version"
    if ((verOffset=nAgt.indexOf("Opera"))!=-1) {
    browserName = "Opera";
    fullVersion = nAgt.substring(verOffset+6);
    if ((verOffset=nAgt.indexOf("Version"))!=-1) 
      fullVersion = nAgt.substring(verOffset+8);
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset=nAgt.indexOf("MSIE"))!=-1) {
    browserName = "Microsoft Internet Explorer";
    fullVersion = nAgt.substring(verOffset+5);
    }
    // In Chrome, the true version is after "Chrome" 
    else if ((verOffset=nAgt.indexOf("Chrome"))!=-1) {
    browserName = "Chrome";
    fullVersion = nAgt.substring(verOffset+7);
    }
    // In Safari, the true version is after "Safari" or after "Version" 
    else if ((verOffset=nAgt.indexOf("Safari"))!=-1) {
    browserName = "Safari";
    fullVersion = nAgt.substring(verOffset+7);
    if ((verOffset=nAgt.indexOf("Version"))!=-1) 
      fullVersion = nAgt.substring(verOffset+8);
    }
    // In Firefox, the true version is after "Firefox" 
    else if ((verOffset=nAgt.indexOf("Firefox"))!=-1) {
    browserName = "Firefox";
    fullVersion = nAgt.substring(verOffset+8);
    }
    // In most other browsers, "name/version" is at the end of userAgent 
    else if ( (nameOffset=nAgt.lastIndexOf(' ')+1) < 
              (verOffset=nAgt.lastIndexOf('/')) ) 
    {
    browserName = nAgt.substring(nameOffset,verOffset);
    fullVersion = nAgt.substring(verOffset+1);
    if (browserName.toLowerCase()==browserName.toUpperCase()) {
      browserName = navigator.appName;
    }
    }
    // trim the fullVersion string at semicolon/space if present
    if ((ix=fullVersion.indexOf(";"))!=-1)
      fullVersion=fullVersion.substring(0,ix);
    if ((ix=fullVersion.indexOf(" "))!=-1)
      fullVersion=fullVersion.substring(0,ix);

    majorVersion = parseInt(''+fullVersion,10);
    if (isNaN(majorVersion)) {
    fullVersion  = ''+parseFloat(navigator.appVersion); 
    majorVersion = parseInt(navigator.appVersion,10);
    }

    return {
      'browser_name'  : browserName,
      'full_version'  : fullVersion,
      'major_version' : majorVersion,
      'navigator_appName' : navigator.appName,
      'navigator_userAgent' : navigator.userAgent
    };
  
  }
  }

